import { Period } from '@geovelo-frontends/commons';
import { useTranslation } from 'react-i18next';

function usePeriod(): { getTitle: (period: Period) => string } {
  const { t } = useTranslation();

  function getTitle({ from, to, title, titleKey }: Period) {
    return (
      title ||
      (titleKey &&
        t(titleKey, {
          from: from.format('L'),
          to: to.format('L'),
          dayFrom: from.format('Do MMM'),
          dayTo: to.format('Do MMM'),
          year: from.format('YYYY'),
        })) ||
      ''
    );
  }

  return { getTitle };
}

export default usePeriod;
